<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(/img/temp/blurred-dark.jpg"></div>
    
      <base-header class="header--recipe pb-6" type="none">
        <b-row align-v="center" class="py-4">
          <b-col xs="12">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <RouteBreadCrumb />
            </nav>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" lg="6" align="left">
            <h3 class="text-white">{{ taggroup.name }}</h3>
            <p class="text-white" v-html="taggroup.description" />
          </b-col>
          <b-col xs="12" lg="6" align="right">
            
            <router-link :to="editLink" v-if="isAdmin"><base-button :to="editLink" v-if="isAdmin" type="secondary" size="sm" class="btn-secondary--alt">Edit Tag Group</base-button></router-link>
            <base-button @click="handleDelete" v-if="isAdmin" type="warning" size="sm" class="edit" icon><i class="far fa-trash-alt"></i></base-button>

          </b-col>
        </b-row>
      </base-header>
    
      <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" body-classes="px-0 pt-2 pb-1" footer-classes="pb-2">
          <div>
            <el-table :data="tags"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results">

              <el-table-column label="Name" min-width="471px" prop="name" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <a :href="'/recipe/' + row.id" class="avatar mr-3 table__avatar" :class="(!row.image)?'avatar--grey':' rounded-circle'">
                      <span>{{ row.name ? row.name.charAt(0) : 'W' }}</span>
                    </a>
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/recipe/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.name }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Date created" min-width="81px" prop="date" sortable>
                <template v-slot="{ row }">
                  <span class="font-weight-600">{{ dateFormat(row.createdOn) }}</span>
                </template>
              </el-table-column>

              <el-table-column min-width="94px" align="last" label="Actions">
                <template v-slot="{ $index, row }">
                  <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light mr-0">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                      <b-dropdown-item @click.native="handleTagView($index, row)">View</b-dropdown-item>
                      <b-dropdown-item v-if="row.userData && row.userData.isOwner && payload.tagId" @click.native="handleRemoveFromTagGroup($index, row, payload.collectionId)">Remove From Tag Group</b-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">

          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import swal from 'sweetalert2'

export default {
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  computed: {
    taggroup() {
      return this.$store.state.taggroups.current;
    },
    tags() {
      return this.$store.state.taggroups.current.tags;
    },
    isAdmin() {
      return this.$store.getters.userIsAdmin
    },
  },
  methods: {
    dateFormat(date) {
      if (date) {
        var local = new Date(date);
        return local.toLocaleDateString("en-US")
      } else {
        return 'No Date'
      }
    },
    handleTagView(index, row) {
      this.$router.push(`/tag/${row.id}`)
    },
    handleDelete() {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const { dispatch } = this.$store;
          dispatch("taggroups/deleteTagGroup", this.taggroup.id);
          this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Tag Group Deleted'});
          this.$router.push({path: "/taggroups"});
        }
      });
    }
  },
  created() {
    this.editLink = `/taggroup/edit-taggroup/${this.$route.params.id}`;
    const { dispatch } = this.$store;
    dispatch("taggroups/getById", this.$route.params.id);
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
